import React, { Component } from 'react';
import {FormGroup, FormControlLabel,  Typography, Box, Radio } from '@material-ui/core';

export default class MenuForm extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  handleChange(menu){
    this.props.onChange([menu]);
  }

  render(){
    const { menus, selectedMenus } = this.props;
    return (
      <React.Fragment>
        <Box marginBottom={1}>
          <Typography>メニューを選択してください</Typography>
          <Typography variant="caption">
            ※オフのみのご予約、ハンドフットの同時予約はこちらからは承れません。LINEでご連絡ください。
          </Typography>
        </Box>
        <FormGroup>        
        {menus.map((menu,i) => {
          const checked = selectedMenus.some((m) => m.id === menu.id);
          return (
            <FormControlLabel
              key={i}
              control={
                <Radio
                  checked={checked}
                  onChange={() => this.handleChange(menu)}
                />
              }
              label={menu.name}
            />
          );
        })}
        </FormGroup>
      </React.Fragment>      
    );
  }
  
}

